/*
 * Banner informativo como carrossel — Ariel Malhas
 * Ativo APENAS no mobile (≤749px). No desktop os benefícios continuam
 * lado a lado, sem qualquer transformação aplicada.
 */
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 749px)');
  var AUTOPLAY_MS = 5000; // rotação automática (4–6s)
  var RESUME_MS = 6000; // retoma após interação do usuário
  var DURATION = 300; // 250–350ms
  var EASING = 'cubic-bezier(0.22, 0.61, 0.36, 1)'; // ease-out
  var SWIPE_RATIO = 0.18;

  function init(root) {
    if (root.__benefitsInit) return;
    root.__benefitsInit = true;

    var track = root.querySelector('[data-benefits-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-benefits-dot]'));
    if (slides.length < 2) return;

    var index = 0;
    var timer = null;
    var resumeTimer = null;
    var dragging = false;
    var startX = 0;
    var delta = 0;
    var width = 0;

    function paint(animate) {
      track.style.transition = animate ? 'transform ' + DURATION + 'ms ' + EASING : 'none';
      track.style.transform = 'translateX(' + -index * 100 + '%)';
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
    }

    function goTo(i, animate) {
      index = ((i % slides.length) + slides.length) % slides.length;
      paint(animate !== false);
    }

    function next() {
      goTo(index + 1);
    }

    function start() {
      stop();
      if (!MOBILE.matches || document.hidden) return;
      timer = window.setInterval(next, AUTOPLAY_MS);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    // Pausa durante a interação e retoma depois de um tempo sem uso.
    function pauseThenResume() {
      stop();
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(start, RESUME_MS);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        pauseThenResume();
      });
    });

    // ----- Swipe -----
    track.addEventListener('pointerdown', function (e) {
      if (!MOBILE.matches) return;
      dragging = true;
      startX = e.clientX;
      delta = 0;
      width = root.getBoundingClientRect().width || 1;
      track.style.transition = 'none';
      stop();
      try {
        track.setPointerCapture(e.pointerId);
      } catch (err) {
        /* noop */
      }
    });

    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      delta = e.clientX - startX;
      track.style.transform = 'translateX(calc(' + -index * 100 + '% + ' + delta + 'px))';
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      try {
        track.releasePointerCapture(e.pointerId);
      } catch (err) {
        /* noop */
      }
      if (Math.abs(delta) > width * SWIPE_RATIO) {
        goTo(delta < 0 ? index + 1 : index - 1);
      } else {
        paint(true);
      }
      delta = 0;
      pauseThenResume();
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    // Liga/desliga conforme o breakpoint
    function sync() {
      if (MOBILE.matches) {
        paint(false);
        start();
      } else {
        stop();
        track.style.transition = 'none';
        track.style.transform = '';
      }
    }

    if (MOBILE.addEventListener) MOBILE.addEventListener('change', sync);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    sync();
  }

  function boot(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-benefits-carousel]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
